// -------------------------------------------------------------------< constants >-------------------------------------------------------------------

// ********************************************************************* users ***********************************************************************

const INDEX_PROFILES_SUCCESS = "INDEX_PROFILES_SUCCESS";
const INDEX_PROFILE_SUCCESS = "INDEX_PROFILE_SUCCESS";

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexProfilesSuccess(payload) {
  return {
    type: INDEX_PROFILES_SUCCESS,
    payload: payload,
  };
}
function _indexProfileSuccess(payload) {
  return {
    type: INDEX_PROFILE_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************* insurances ********************************************************************

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @param {String} [component='personnel']
 * @return {Function}
 */
export function indexProfiles(
  params = {},
  callback = () => {},
  component = "personnel"
) {
  return (dispatch, gs, api) => { 
     console.log("parsdfdams",params);

    // THIS SHIT WAS NOT MY IDEA, BUT SEEMS LIKE I SHOULD STOP THINKING HERE SO... LET'S NOT GIVE A F***
    api
      .get("/users/profiles", { params })
  
      .then((res) => {
        dispatch(_indexProfilesSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.basic.personnel",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate("routes.home.basic.personnel.Indexing Personnel Failed")
        );
        // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
        callback(err);
      });
  };
}

export function indexProfile(
  id = "",
  params = {},
  callback = () => {},
  component = "personnel"
) {
  return (dispatch, gs, api) => {
    // THIS SHIT WAS NOT MY IDEA, BUT SEEMS LIKE I SHOULD STOP THINKING HERE SO... LET'S NOT GIVE A F***
    if (app.can("User@index")) {
      if (component === "personnel") {
        // if (app.can('User@all')) {
        api
          .get(`/users/profiles/${id}`, { params })
          .then((res) => {
            dispatch(_indexProfileSuccess(res));
            callback(undefined, res);
          })
          .catch((err) => {
            app.error(
              err,
              "routes.home.basic.personnel",
              ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
              app.translate(
                "routes.home.basic.personnel.Indexing Personnel Failed"
              )
            );
            // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
            callback(err);
          });
        // } else if (app.can('User@sub')) {
        //   let _params = params;
        //   if(app.can('User@self')){
        //     _params['me'] = true;
        //   }
        //
        //   api.get(`/user/subset/${id}`, { params: _params })
        //     .then((res) => {
        //       dispatch(_indexProfileSuccess(res));
        //       callback(undefined, res);
        //     })
        //     .catch((err) => {
        //       app.error(err, 'routes.home.basic.personnel', 'User', app.translate('routes.home.basic.personnel.Indexing Personnel Failed'));
        //       // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
        //       callback(err);
        //     });
        // } else if (app.can('User@self')) {
        //   api.get(`/user/${id}`, { params })
        //     .then((res) => {
        //       dispatch(_indexProfileSuccess({ data: { users: [res.data.user] } }));
        //       callback(undefined, res);
        //     })
        //     .catch((err) => {
        //       app.error(err, 'routes.home.basic.personnel', 'User', app.translate('routes.home.basic.personnel.Indexing Personnel Failed'));
        //       // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
        //       callback(err);
        //     });
        // }
      } else if (component === "clocking") {
        // if (app.can('Clocking@all')) {
        api
          .get(`/users/${id}`, { params })
          .then((res) => {
            dispatch(_indexProfileSuccess(res));
            callback(undefined, res);
          })
          .catch((err) => {
            app.error(
              err,
              "routes.home.basic.personnel",
              ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
              app.translate(
                "routes.home.basic.personnel.Indexing Personnel Failed"
              )
            );
            // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
            callback(err);
          });
        // } else if (app.can('Clocking@sub')) {
        //   if(app.can('Clocking@self')){
        //     params['me'] = true;
        //   }
        //   api.get(`/user/subset/${id}`, { params })
        //     .then((res) => {
        //       dispatch(_indexProfileSuccess(res));
        //       callback(undefined, res);
        //     })
        //     .catch((err) => {
        //       app.error(err, 'routes.home.basic.personnel', 'User', app.translate('routes.home.basic.personnel.Indexing Personnel Failed'));
        //       // app.message(app.translate('routes.home.basic.personnel.Indexing Personnel Failed'), 'error');
        //       callback(err);
        //     });
        // }
      }
    }
  };
}
/**
 * @param {Number} id
 * @param {Object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequest2(id, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (id) {
      api
        .get(`/Users/GetFullName?personnelId=${id}`)
        .then((r) => {
          // console.log('ق', r);
          console.log("1231", r);

          // dispatch(_showRequestSuccess(r));
          callback(r);
        })
        .catch((e) => {
          // console.log('', e);
        });
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    profiles: [],
    profile: {},
  },
  action
) {
  let meta;
  switch (action.type) {
    case INDEX_PROFILES_SUCCESS:
      meta = action.payload.meta;
      return Object.assign({}, state, {
        profiles: action.payload.data.profiles,
        pagination: meta
          ? app.pagination(meta.currentPage + 1, meta.total, meta.limit)
          : {},
        usersMeta: meta,
      });
    case INDEX_PROFILE_SUCCESS:
      meta = action.payload.meta;
      return Object.assign({}, state, {
        profile: action.payload.data.profile,
        pagination: meta
          ? app.pagination(meta.currentPage + 1, meta.total, meta.limit)
          : {},
        userMeta: meta,
      });
    default:
      return state;
  }
}
